import React, { useEffect } from 'react';
import { styled } from 'linaria/react';
import { useTracker } from '@jetshop/core/analytics/Analytics';
import { trackListEvent } from '@jetshop/core/analytics/tracking';
import { RelatedProduct } from './RelatedProduct';

const RelatedWrapper = styled('div')`
  margin: 2rem 0 1rem 0;
  width: 100%;
  > h3 {
    margin: 1rem 0;
  }
  .related-product-grid {
    display: flex;
    flex-wrap: wrap;
    > * {
      width: 100%;
    }
  }
`;

const RelatedProductsAddon = ({ products, title }) => {
  //TRACK LIKE PRODUCTGRID
  const track = useTracker();
  useEffect(() => {
    // Dont track anything if there are no products to render
    if (!products || products.length === 0) return;
    // Otherwise track a list view event
    track(trackListEvent({ listName: 'Related Products Addon', products }));
  }, [products, track]);

  if (!products) return null;

  // REMOVE DISCONTINUED PRODUCTS
  products = products?.filter(product => (product?.stockStatus.stockStatusId !== "100"));


  return (
    <RelatedWrapper id="related-products">
      <h3>{title}</h3>
      <div className="related-product-grid">
        {products.map((product, index) => {
          return (
            <RelatedProduct product={product} quickBuy={true} key={index} />
          );
        })}
      </div>
    </RelatedWrapper>
  );
};

export default RelatedProductsAddon;
